import { Component } from '@angular/core';

@Component({
  templateUrl: './job-order-report.page.html',
})
export class JobOrderReportPageComponent {}
